import React from 'react';
import { Globe, Activity, Layers, LogOut, ChevronRight } from 'lucide-react';
import { AgentFilters } from '../utils/agentMatrix';
interface SettingsPageProps {
  filters: AgentFilters;
  onEditFilters: () => void;
  onLogout: () => void;
  isAdminUnlocked?: boolean;
}
export function SettingsPage({
  filters,
  onEditFilters,
  onLogout,
  isAdminUnlocked = false
}: SettingsPageProps) {
  return <div className="w-full px-6 pb-32 pt-4" data-id="element-485">
      <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-486">Settings</h2>

      {/* Filter Settings Cards */}
      <div className="space-y-3 mb-8" data-id="element-487">
        {/* Lead Source */}
        <button onClick={onEditFilters} className="w-full bg-white rounded-2xl p-5 flex items-center justify-between shadow-sm hover:shadow-md transition-shadow active:scale-[0.99]" data-id="element-488">
          <div className="flex items-center gap-4" data-id="element-489">
            <div className="w-12 h-12 bg-gray-100 rounded-xl flex items-center justify-center" data-id="element-490">
              <Globe className="w-6 h-6 text-gray-600" data-id="element-491" />
            </div>
            <div className="text-left" data-id="element-492">
              <p className="text-sm text-gray-500 font-medium" data-id="element-493">Lead Source</p>
              <p className="text-xl font-bold text-gray-900" data-id="element-494">
                {isAdminUnlocked ? filters.leadSource : 'All'}
              </p>
            </div>
          </div>
          <div className="w-12 h-12 bg-black rounded-full flex items-center justify-center" data-id="element-495">
            <ChevronRight className="w-6 h-6 text-white" data-id="element-496" />
          </div>
        </button>

        {/* Difficulty */}
        <button onClick={onEditFilters} className="w-full bg-white rounded-2xl p-5 flex items-center justify-between shadow-sm hover:shadow-md transition-shadow active:scale-[0.99]" data-id="element-497">
          <div className="flex items-center gap-4" data-id="element-498">
            <div className="w-12 h-12 bg-gray-100 rounded-xl flex items-center justify-center" data-id="element-499">
              <Activity className="w-6 h-6 text-gray-600" data-id="element-500" />
            </div>
            <div className="text-left" data-id="element-501">
              <p className="text-sm text-gray-500 font-medium" data-id="element-502">Difficulty</p>
              <p className="text-xl font-bold text-gray-900" data-id="element-503">
                {isAdminUnlocked ? `${filters.difficulty}/10` : 'Random'}
              </p>
            </div>
          </div>
          <div className="w-12 h-12 bg-black rounded-full flex items-center justify-center" data-id="element-504">
            <ChevronRight className="w-6 h-6 text-white" data-id="element-505" />
          </div>
        </button>

        {/* Interest */}
        <button onClick={onEditFilters} className="w-full bg-white rounded-2xl p-5 flex items-center justify-between shadow-sm hover:shadow-md transition-shadow active:scale-[0.99]" data-id="element-506">
          <div className="flex items-center gap-4" data-id="element-507">
            <div className="w-12 h-12 bg-gray-100 rounded-xl flex items-center justify-center" data-id="element-508">
              <Layers className="w-6 h-6 text-gray-600" data-id="element-509" />
            </div>
            <div className="text-left" data-id="element-510">
              <p className="text-sm text-gray-500 font-medium" data-id="element-511">Interest</p>
              <p className="text-xl font-bold text-gray-900 truncate max-w-[180px]" data-id="element-512">
                {isAdminUnlocked ? filters.productInterest || 'Any' : 'All Services'}
              </p>
            </div>
          </div>
          <div className="w-12 h-12 bg-black rounded-full flex items-center justify-center" data-id="element-513">
            <ChevronRight className="w-6 h-6 text-white" data-id="element-514" />
          </div>
        </button>
      </div>

      {/* Account Section */}
      <div className="space-y-3" data-id="element-515">
        <h3 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-516">Account</h3>

        {/* Logout Button */}
        <button onClick={onLogout} className="w-full bg-white rounded-2xl p-5 flex items-center justify-between shadow-sm hover:shadow-md transition-shadow active:scale-[0.99] border-2 border-red-100 hover:border-red-200" data-id="element-517">
          <div className="flex items-center gap-4" data-id="element-518">
            <div className="w-12 h-12 bg-red-50 rounded-xl flex items-center justify-center" data-id="element-519">
              <LogOut className="w-6 h-6 text-red-600" data-id="element-520" />
            </div>
            <div className="text-left" data-id="element-521">
              <p className="text-lg font-bold text-red-600" data-id="element-522">Switch Rep</p>
              <p className="text-xs text-gray-500" data-id="element-523">Log out and change user</p>
            </div>
          </div>
          <ChevronRight className="w-6 h-6 text-red-600" data-id="element-524" />
        </button>
      </div>
    </div>;
}